import React from 'react';

const Header: React.FC = () => {
  return (
    <header className="mb-8">
      <h1 className="text-3xl font-bold text-violet-700 leading-tight">Bibliothèque de prix</h1>
      <p className="mt-2 text-base text-gray-600">Chercher une prestation dans vos projets antérieurs</p>
    </header>
  );
};

export default Header; 